import { ErrorMessage, Field, getIn } from 'formik';
import React from 'react';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';
import * as Yup from 'yup';

const algorithmTypes = [
  { value: 'alphanumeric', label: 'Auto Increment Alpha Numeric (0-9,A-Z)' },
  { value: 'numeric', label: 'Auto Increment Numeric (0-9)' },
  { value: 'randomNumeric', label: 'Random Numeric (0-9)' },
  { value: 'randomAlphabet', label: 'Random Alphabet (A-Z)' },
  { value: 'randomAlphanumeric', label: 'Random Alpha Numeric (0-9,A-Z)' },
];

const CustomUUIDExtraSetting = ({ setFieldValue, setFieldTouched, values }) => {
  const isRandom = ['randomAlphanumeric', 'randomNumeric', 'randomAlphabet'].includes(
    values.extraFieldSetting.algorithm,
  );
  const numberFieldValidate = value =>
    isRandom && value < 6 ? 'Must greater than or equals to 6' : '';
  return (
    <>
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <CustomInputWithIcon icon="select">
          <CustomSelect
            key="algorithm"
            name="extraFieldSetting.algorithm"
            isMulti={false}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            options={algorithmTypes}
            value={getIn(values, 'algorithm')}
            placeholder="Select Algorithm"
          />
          <p className="errors">
            <ErrorMessage name="extraFieldSetting.algorithm" />
          </p>
        </CustomInputWithIcon>
      </div>
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <CustomInputWithIcon icon="sidebar">
          <Field
            type="text"
            name="extraFieldSetting.prepend"
            className="form-control"
            placeholder="Append some text before string"
          />
          <p className="errors">
            <ErrorMessage name="extraFieldSetting.prepend" />
          </p>
        </CustomInputWithIcon>
      </div>
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <CustomInputWithIcon icon="reverse-sidebar">
          <Field
            type="text"
            name="extraFieldSetting.append"
            className="form-control"
            placeholder="Append some text after string"
          />
          <p className="errors">
            <ErrorMessage name="extraFieldSetting.append" />
          </p>
        </CustomInputWithIcon>
      </div>
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <CustomInputWithIcon icon="number">
          <Field
            type="number"
            name="extraFieldSetting.minLength"
            className="form-control"
            placeholder="Min Length of UUID"
            validate={numberFieldValidate}
          />
          <p className="errors">
            <ErrorMessage name="extraFieldSetting.minLength" />
          </p>
        </CustomInputWithIcon>
        {isRandom && (
          <small style={{ marginLeft: '4em' }}>
            ( Random numbers should be of 6 characters or more )
          </small>
        )}
      </div>
    </>
  );
};

export default CustomUUIDExtraSetting;
